import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { Modal } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import useLeadService, { CONVERT_LEAD } from 'domain/sales/lead/shared/leadService';
import { validate } from 'validation-schema-library';
import { useLeadUrl } from 'domain/shared/lead';
import type { Data } from 'framework/types';
import { ValidationSchema } from 'validation-schema-library/build/validation/utils';

const ConvertButton = () => {
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const navigate = useNavigate();
  const { isGranted } = useAuthorization();
  const { getUpdateEntityUrl, getConvertUrl } = useLeadUrl();

  const { data: lead } = useShowContext();
  const { getValidationSchema } = useLeadService();
  const [validationSchema, setValidationSchema] = useState<Nullable<ValidationSchema>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getValidationSchema().then(schema => {
      setValidationSchema(schema);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isValid = (data: Data) => {
    // @ts-ignore
    const errors = validate({
      schema: validationSchema,
      fullObject: data.getData(),
      isCreateRequest: false,
      exceptions: { status: 'QUALIFIED' },
    });
    return Object.keys(errors).length === 0;
  };

  const editLeadBeforeConvert = (leadId: StringOrNumber) => {
    setIsConvertModalOpen(false);
    navigate(getUpdateEntityUrl(leadId), {
      state: { status: 'CONVERT' },
    });
  };

  const editBtn = (
    <Button
      key="editBtn"
      onClick={() => {
        editLeadBeforeConvert(lead.getValueBySource('id'));
      }}
    >
      Edit Lead
    </Button>
  );

  return isGranted(CONVERT_LEAD) && lead.getValueBySource('status') === 'OPEN' ? (
    <>
      <Button
        disabled={loading}
        color="secondary"
        onClick={() =>
          isValid(lead) ? navigate(getConvertUrl(lead.getValueBySource('id'))) : setIsConvertModalOpen(true)
        }
      >
        <span>Convert</span>
      </Button>
      <Modal
        isOpen={isConvertModalOpen}
        title="Validation errors"
        buttons={[editBtn]}
        onToggle={() => setIsConvertModalOpen(false)}
      >
        <span>Convert cannot be completed. Required fields are missing. Proceed to ‘Edit Lead’?</span>
      </Modal>
    </>
  ) : null;
};

export default ConvertButton;
